import { call, put, takeLatest } from 'redux-saga/effects';
import { subscribeEmail } from '../api/scanApi';
import {
  SUBSCRIBE_REQUEST,
  SUBSCRIBE_SUCCESS,
  SUBSCRIBE_FAILURE,
} from '../actions/subscribeActions';

function* runSubscribe(action) {
  try {
    const { data } = yield call(subscribeEmail, action.payload);
    yield put({ type: SUBSCRIBE_SUCCESS, payload: data?.message ?? null });
  } catch (error) {
    yield put({ type: SUBSCRIBE_FAILURE, payload: 'email' });
  }
}

export default function* subscribeSaga() {
  yield takeLatest(SUBSCRIBE_REQUEST, runSubscribe);
}
